<template>
  <div id="decision_start">
    <w-datepicker :model="schema.actionDataToPass.startDate" />

    <div class="mt-3">
      <p class="label">Zakresy dat decyzji</p>

      <w-warnings
        v-if="schema.actionDataToPass.dateRanges.$error"
        :model="schema.actionDataToPass.dateRanges"
        :display-errors="true"
      />

      <decision-ranges :model="schema.actionDataToPass.dateRanges" :types="decisionDatesTypes" :with-amount="false" />
    </div>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';
import { mapState } from 'vuex';

import { DecisionCalculationType, DecisionCalculationTypeTranslation } from '@/enums/decisionCalculationType';

import DecisionRanges from '../decision/DecisionRanges.vue';

// @vuese
// Formularz daty początku decyzji
// @group ActionData
export default {
  components: { ...components, DecisionRanges },
  props: {
    // schema
    schema: { type: Object, required: true }
  },
  data() {
    return {
      decisionDatesTypes: [
        { value: DecisionCalculationType.AMOUNT, text: DecisionCalculationTypeTranslation.AMOUNT },
        { value: DecisionCalculationType.INVOICE, text: DecisionCalculationTypeTranslation.INVOICE },
        { value: DecisionCalculationType.HOLD, text: DecisionCalculationTypeTranslation.HOLD },
        { value: DecisionCalculationType.WITHDRAWAL, text: DecisionCalculationTypeTranslation.WITHDRAWAL }
      ]
    };
  },
  computed: {
    ...mapState({
      dateRanges: state => state.decision.dateRanges
    })
  },
  mounted() {
    this.setSchemaData(this.dateRanges);
  },
  methods: {
    setSchemaData(value) {
      if (value === this.schema.actionDataToPass.dateRanges.$model) {
        return;
      }

      if (!value) {
        this.schema.actionDataToPass.dateRanges.$setData(null);
        return;
      }

      this.schema.actionDataToPass.dateRanges.$setData(value);
    }
  }
};
</script>

<style>
@media (min-width: 1000px) {
  .modal-dialog:has(#decision_start) {
    max-width: 900px;
  }
}
</style>
